import { render, staticRenderFns } from "./mraChart.vue?vue&type=template&id=70018423"
import script from "./mraChart.vue?vue&type=script&lang=js"
export * from "./mraChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports